import React from "react";
import styled from "styled-components";
import cx from "classnames";
import Loader from "../../../../../../components/loader";

const LoaderBackgroundWrapper = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 1s;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  
  &.loading {
    opacity: 1;
    pointer-events: all;
  }
`;

export const LoaderBackground = ({loading}) => (
  <LoaderBackgroundWrapper className={cx({loading})}>
    <Loader loading />
  </LoaderBackgroundWrapper>
);